import React, { useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { RecaptchaProps } from '../types/recatptcha-props';
import { useRecaptchaSize } from '../hooks/useRecaptchaSize';
import { RecaptchaError } from '../Error';
import { RecaptchaRoot } from '../Root';
import { RecaptchaWrapper } from '../Wrapper';

const RecaptchaV2: React.FC<RecaptchaProps> = ({ timestamp, captchaKey, error, errorText, onChange }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const captchaRef = useRef<ReCAPTCHA>();

  const { width, height, scale } = useRecaptchaSize(wrapperRef);

  useEffect(() => {
    captchaRef.current?.reset();
  }, [timestamp, captchaKey]);

  return (
    <RecaptchaRoot ref={wrapperRef}>
      <RecaptchaWrapper width={width} height={height}>
        {/* @ts-ignore */}
        <ReCAPTCHA
          ref={captchaRef}
          sitekey={captchaKey}
          onChange={onChange}
          style={{
            transformOrigin: 'left top',
            transform: `scale(${scale})`,
          }}
        />
      </RecaptchaWrapper>
      <RecaptchaError error={error} errorText={errorText} />
    </RecaptchaRoot>
  );
};

export default React.memo(RecaptchaV2);
